//健康检查信息维护
const apiHitIotHC = {};
export default apiHitIotHC;
